// 如果本地缓存里有hide，就将hide赋值
//目前先弃用
let defaultHide = true
try {
  if (localStorage.hide) {
    defaultHide = localStorage.hide
  }
} catch (e) {}

export default {
    hide: defaultHide
}